import { render, staticRenderFns } from "./HtmlEditor.vue?vue&type=template&id=3f85a8e0"
import script from "./HtmlEditor.vue?vue&type=script&lang=js"
export * from "./HtmlEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports